import React from 'react';
import '../styles/MuseCard.css';

export interface MuseCardProps {
  img?: string;
  name?: string;
  emoji?: string;
  rarity?: string;
  count?: number;
  onClick?: () => void;
  size?: 'small' | 'medium' | 'large';
  locked?: boolean;
  pack?: string | null;
}

const MuseCard: React.FC<MuseCardProps> = ({ 
  img, 
  name, 
  emoji, 
  rarity, 
  count, 
  onClick, 
  size = 'medium', 
  locked = false, 
  pack = null 
}) => {
  const sizeClass = size.toLowerCase();
  const rarityClass = rarity ? rarity.toLowerCase() : '';
  const packClass = pack ? pack.toLowerCase() : '';
  const clickableClass = onClick ? 'clickable' : '';
  const lockedClass = locked ? 'locked' : '';

  return (
    <div 
      className={`muse-card ${clickableClass}`}
      onClick={onClick}
    >
      <div className={`muse-circle ${sizeClass} ${rarityClass} ${packClass} ${lockedClass}`}>
        {!locked && (
          img ? (
            <img 
              src={img} 
              alt={name || 'muse'} 
              className="muse-avatar-img" 
              style={{ 
                width: '100%', 
                height: '100%', 
                objectFit: 'cover'
              }} 
            />
          ) : (
            <span className="muse-emoji">{emoji}</span>
          )
        )}
      </div>
      {!locked && (
        <>
          <div className="muse-rarity">{rarity}</div>
          {count !== undefined && <div className="muse-count">× {count}</div>}
        </>
      )}
    </div>
  );
};

export default MuseCard;
